export default "__VITE_ASSET__ef7f3a55__"